import React, { Component } from "react";
import FadeIn from "react-fade-in/lib/FadeIn";
import {
  Status,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  FormInput,
} from "ui-kit-ck-consultant";

import { getValue, months } from "../../../utils/general";
import { formatStat, roundStat } from "./statFormat";

import AuthContext from "../../../context/AuthContext";

export class TableQuality extends Component {
  getLabels = () => {
    return [
      {
        id: "tauxCancelAndReplace",
        name: "Tx d'annule et remplace (%)",
      },
      {
        id: "tauxInvoiceValidation",
        name: "Validation facture (%)",
      },
      {
        id: "precision",
        name: "Précision (%)",
      },
    ];
  };

  static contextType = AuthContext;

  getEvolution = (data1, data2, name) => {
    const inversedColorList = [
      "Tarif horaire (€ HT)",
      "Délai mission-visite (j)",
      "Délai visite-dépôt (j)",
      "Délai mission-dépôt (j)",
      "Coût pièces (€ HT)",
      "Nombre heures (h)",
      "Nombre heures peinture (h)",
      "Coût réparation (€ HT)",
      "Dossiers (Coût réparation 1500/2300 € HT) (%)",
      "Dossiers (Coût réparation 2300/4600 € HT) (%)",
      "Dossiers (Coût réparation >= 4600 € HT) (%)",
    ];

    if (data1 && data2) {
      const value = roundStat((data2 / data1) * 100 - 100);
      if (inversedColorList.includes(name)) {
        if (value > 0) {
          return (
            <Status
              className="bg-red-light black w-100 nowrap"
              text={`${getValue(value)} %`}
            />
          );
        } else if (value < 0) {
          return (
            <Status
              className="bg-green-light black w-100 nowrap"
              text={`${getValue(value)} %`}
            />
          );
        } else {
          return <Status className="bg-blue-light black w-100" text="0,00 %" />;
        }
      } else {
        if (value > 0) {
          return (
            <Status
              className="bg-green-light black w-100 nowrap"
              text={`${getValue(value)} %`}
            />
          );
        } else if (value < 0) {
          return (
            <Status
              className="bg-red-light black w-100 nowrap"
              text={`${getValue(value)} %`}
            />
          );
        } else {
          return <Status className="bg-blue-light black w-100" text="0,00 %" />;
        }
      }
    } else {
      return <Status className="bg-blue-light black w-100" />;
    }
  };

  getCell = (idx, row) =>
    this.props.data[idx]
      ? formatStat(this.props.data[idx][row.id], row.isCount)
      : null;

  render() {
    return (
      <FadeIn className={"overflow-x-auto"}>
        <Table>
          <Thead>
            <Tr>
              <Th hide></Th>
              <Th radiusTopLeft>Cible</Th>
              <Th>N-1</Th>
              <Th>N</Th>
              <Th spaceRight>N/N-1</Th>
              {months.map((month, idx) => (
                <Th key={idx} spaceLeft={idx === 0}>
                  {month}
                </Th>
              ))}
            </Tr>
          </Thead>
          <Tbody>
            {this.getLabels().map((row, idx) => {
              return (
                <Tr key={idx}>
                  <Th radiusTopLeft={idx === 0}>{row.name}</Th>
                  <Td style={{ padding: 0 }}>
                    {this.context.role === 1 ? (
                      <FormInput
                        type="number"
                        styleInput={{
                          border: "none",
                          padding: "0 10px",
                          fontSize: 12,
                          height: 36,
                          borderRadius: 0,
                        }}
                        style={{
                          width: "80px",
                        }}
                        value={
                          this.props.performanceAgency[
                            `Q${this.props.company || ""}_${row.id}`
                          ] || ""
                        }
                        onChange={(e) =>
                          this.props.updatePerformanceAgency(
                            `Q${this.props.company || ""}_${row.id}`,
                            e.target.value
                          )
                        }
                        onBlur={() => this.props.leaveUpdatePerformanceAgency()}
                      />
                    ) : (
                      this.props.performanceAgency[
                        `Q${this.props.company || ""}_${row.id}`
                      ] || ""
                    )}
                  </Td>
                  <Td>
                    {this.props.data[0][row.id]
                      ? formatStat(this.props.data[0][row.id], row.isCount)
                      : null}
                  </Td>
                  <Td>
                    {this.props.data[1][row.id]
                      ? formatStat(this.props.data[1][row.id], row.isCount)
                      : null}
                  </Td>
                  <Td spaceRight>
                    {this.getEvolution(
                      this.props.data[0][row.id],
                      this.props.data[1][row.id],
                      row.name
                    )}
                  </Td>
                  <Td spaceLeft>
                    {this.props.data[2][row.id]
                      ? formatStat(this.props.data[2][row.id], row.isCount)
                      : null}
                  </Td>
                  <Td>
                    {this.getCell(3, row)}
                  </Td>
                  <Td>
                    {this.getCell(4, row)}
                  </Td>
                  <Td>
                    {this.getCell(5, row)}
                  </Td>
                  <Td>
                    {this.getCell(6, row)}
                  </Td>
                  <Td>
                    {this.getCell(7, row)}
                  </Td>
                  <Td>
                    {this.getCell(8, row)}
                  </Td>
                  <Td>
                    {this.getCell(9, row)}
                  </Td>
                  <Td>
                    {this.getCell(10, row)}
                  </Td>
                  <Td>
                    {this.getCell(11, row)}
                  </Td>
                  <Td>
                    {this.getCell(12, row)}
                  </Td>
                  <Td>
                    {this.getCell(13, row)}
                  </Td>
                </Tr>
              );
            })}
          </Tbody>
        </Table>
      </FadeIn>
    );
  }
}

export default TableQuality;
